export interface VenueAnalysisLiquidity {
    index: number;
    name: string;
    className: string;
    liquidityCodeValues: string[];
}

const auction: VenueAnalysisLiquidity = {
    index: 0,
    name: 'Auction',
    className: 'liquidity-auction',
    liquidityCodeValues: ['4', 'C'],
};
const added = {
    index: 1,
    name: 'Added',
    className: 'liquidity-added',
    liquidityCodeValues: ['1'],
};
const conditional = {
    index: 2,
    name: 'Conditional',
    className: 'liquidity-conditional',
    liquidityCodeValues: ['8', '9'],
};
const removed = {
    index: 3,
    name: 'Removed',
    className: 'liquidity-removed',
    liquidityCodeValues: ['2'],
};
const triggered = {
    index: 4,
    name: 'Triggered',
    className: 'liquidity-triggered',
    liquidityCodeValues: ['5', '6', '7'],
};
const routed = {
    index: 5,
    name: 'Routed',
    className: 'liquidity-routed',
    liquidityCodeValues: ['3'],
};
const other = {
    index: 6,
    name: 'Other',
    className: 'liquidity-other',
    liquidityCodeValues: [],
};

export const venueAnalysisLiquidities: VenueAnalysisLiquidity[] = [
    auction,
    added,
    conditional,
    removed,
    triggered,
    routed,
    other,
];

export function getVenueAnalysisLiquidity(
    liquidityCode: string
): VenueAnalysisLiquidity {
    for (const liquidity of venueAnalysisLiquidities) {
        if (liquidity.liquidityCodeValues.indexOf(liquidityCode) > -1) {
            return liquidity;
        }
    }
    return other;
}
